import { Brand, Pair, createBranded, createBrandedPair } from '@deltasierra/type-utilities';
import { LocationId } from '../location';
import { HasId } from '../common';

export interface ScheduledEmail extends HasId<ScheduledEmailId> {
    batchId: ScheduledEmailBatchId;
    content: string;
    lists: string[];
    scheduledDate: Date;
    subject: string;
    templateId: ScheduledEmailTemplateId;
}

/**
 * This is the Pair of a LocationId and a BatchId
 */
export type ScheduledEmailId = Pair<LocationId, number, 'ScheduledEmailId'>;
export const ScheduledEmailId = createBrandedPair<ScheduledEmailId>();

export type ScheduledEmailBatchId = Brand<number, 'ScheduledEmailBatchId'>;
export const ScheduledEmailBatchId = createBranded<ScheduledEmailBatchId>();

export type ScheduledEmailTemplateId = Brand<number, 'ScheduledEmailTemplateId'>;
export const ScheduledEmailTemplateId = createBranded<ScheduledEmailTemplateId>();
